import React, { FC, useEffect, useState } from 'react';
import Paper from '@mui/material/Paper';
import Hidden from '@mui/material/Hidden';
import { useTranslation } from 'react-i18next';
import { Box, Step, StepLabel, Stepper } from '@mui/material';

import PatientStep from 'components/order-flow/action-order/patient-step/patient-step.component';
import ConstructionsStep from 'components/order-flow/action-order/constructions-step/constructions-step.component';
import LabDeliveryStep from 'components/order-flow/action-order/lab-delivery-step/lab-delivery-step.component';
import ConfirmStep from 'components/order-flow/action-order/confirm-step/confirm-step.component';
import { permissions } from 'utils/permission';
import { currentUserVar } from 'apollo/reactive-variables/user';

const ActionOrder: FC = () => {
    const { t: translate } = useTranslation(['orders']);
    const [activeStep, setActiveStep] = useState(0);
    const currentUser = currentUserVar();

    const getSteps = () => {
        return [
            translate('PATIENT'),
            translate('CONSTRUCTIONS_FILES'),
            translate('LAB_DELIVERY'),
            translate('CONFIRM'),
        ];
    };

    useEffect(() => {
        if (permissions.isLabTechnician(currentUser.type)) {
            setActiveStep(1);
            return;
        }
        setActiveStep(0);
    }, []);

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [activeStep]);

    const getStepContent = () => {
        switch (activeStep) {
            case 0:
                return <PatientStep onNextClick={handleNext} />;
            case 1:
                return <ConstructionsStep onBackClick={handleBack} onNextClick={handleNext} />;
            case 2:
                return <LabDeliveryStep onBackClick={handleBack} onNextClick={handleNext} />;
            case 3:
                return <ConfirmStep onBackClick={handleBack} />;
            default:
                return 'Unknown stepIndex';
        }
    };

    const steps = getSteps();

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleStepperClick = (step: number) => {
        if (step < activeStep) {
            setActiveStep(step);
        }
    };

    return (
        <Box sx={{ maxWidth: '1200px' }} display="flex" flexDirection="column" mx="auto">
            <Box mb={2}>
                <Hidden mdDown>
                    <Stepper activeStep={activeStep}>
                        {steps.map((label, index) => (
                            <Step sx={{ cursor: 'pointer' }} key={label} onClick={() => handleStepperClick(index)}>
                                <StepLabel>{label}</StepLabel>
                            </Step>
                        ))}
                    </Stepper>
                </Hidden>
            </Box>
            <Paper elevation={1}>
                <Box p={3}>{getStepContent()}</Box>
            </Paper>
        </Box>
    );
};

export default ActionOrder;
